import { render, staticRenderFns } from "./AdminExtensions.vue?vue&type=template&id=3d8b487d"
import script from "./AdminExtensions.vue?vue&type=script&lang=js"
export * from "./AdminExtensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports